import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { flyout_outerBlockVSpacing, spacing } from 'ext-ui/style/spacing'
import { fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${flyout_outerBlockVSpacing};
  position: relative;

  .details {
    display: flex;
    flex-direction: row;
    gap: ${spacing(2)};
    align-items: center;
    ${fontRegular}
    color: ${text_colorTextPrimary};

    & > *:not(:first-child) {
      display: flex;
      gap: ${spacing(2)};
      align-items: center;

      ::before {
        content: '•';
        color: ${text_colorTextSecondary};
        ${fontRegular};
      }
    }
  }

  .timeline {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 18px; // Center of 36px diameter icons
      width: 1px;
      // Expecting that this timeline list will eventually have
      // a variable number of timeline-events in it, so making
      // the height 100% of the parent .timeline container with
      // slight adjustment to account for the icon not being the
      // full height of the timeline-event row, and the row's v padding
      height: calc(100% - 6px);
      background-color: ${base_colorContentBorder};
    }

    .timeline-event {
      display: flex;
      align-items: flex-start;
      gap: ${spacing(3)};
      position: relative;
    }
  }
`

export const iconStyle = css`
  width: ${spacing(5)};
  height: ${spacing(5)};
`
